export default __webpack_public_path__ + "static/media/logo.9149ce52.svg";